var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "text-body-2", attrs: { "data-qa": "lpu_partners" } },
    [
      _c("div", { staticClass: "mb-2" }, [
        _vm._v("\n    Данные предоставили клиники:\n  "),
      ]),
      _vm._v(" "),
      _c(
        "ul",
        {
          staticClass: "lpu-partners__list d-flex flex-column gr-1 pa-0 ma-0",
          attrs: { "data-qa": "lpu_partners_list" },
        },
        _vm._l(_setup.context.doctor_practice.from_lpus, function (lpu, i) {
          return _c(
            "li",
            {
              key: i,
              staticClass: "d-flex ga-1 align-start",
              attrs: { "data-qa": "lpu_partners_item" },
            },
            [_vm._v("\n      " + _vm._s(lpu) + "\n    ")]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }